import { useEffect } from 'react'
import { useT } from '../lib/i18n'
import { useCallStore } from '../stores/callStore'

/**
 * A line about a call that stopped without the user saying so — currently "Yousef declined the
 * call", from the `call.end` frame's `by` (A15). Without it the caller's screen simply vanished.
 *
 * Same banner as `ReloadPrompt`: below the header, at the inline-end, dismissible, and never over
 * the composer. Auto-dismisses, because it reports something that already happened.
 */
export function CallNotice() {
  const t = useT()
  const notice = useCallStore((state) => state.notice)
  const clearNotice = useCallStore((state) => state.clearNotice)

  useEffect(() => {
    if (notice === null) return
    const handle = setTimeout(clearNotice, 8000)
    return () => clearTimeout(handle)
  }, [notice, clearNotice])

  if (notice === null) return null

  return (
    <div
      role="status"
      className="panel-enter fixed end-3 top-[calc(var(--sat)+var(--header-h)+8px)] z-40 flex max-w-[calc(100%-24px)] items-center gap-2 rounded-panel border-s-2 border-accent bg-surface/95 py-1.5 ps-3 pe-1.5 text-ink shadow-lift backdrop-blur-sm ring-1 ring-line-strong"
    >
      <span className="text-meta">
        <bdi>{notice}</bdi>
      </span>
      <button
        type="button"
        onClick={clearNotice}
        className="min-h-11 rounded-full px-3 text-meta text-muted transition-colors duration-quick hover:bg-surface2 hover:text-ink"
      >
        {t('call.dismiss')}
      </button>
    </div>
  )
}
